exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zones__item[data-v-749e6cae] {\n  cursor: pointer;\n}\n.zones .btn[data-v-749e6cae] {\n  width: 100%;\n}\n.icon[data-v-749e6cae] {\n  cursor: pointer;\n}", ""]);

// exports
